module.exports = __webpack_public_path__ + "img/avida.a8599d6.png";